import type { EntityUserNestedProfile } from '@features/user/types/user';

/** Format roles as "Department: role, role" lines grouped by department. */
export function formatRolesByDepartment(
  profiles: EntityUserNestedProfile[] | undefined
): string {
  if (!profiles?.length) {
    return 'No roles assigned';
  }

  const byDept = new Map<string, string[]>();
  for (const profile of profiles) {
    const dept = profile.department_name;
    const role = profile.profile_description || profile.profile_code;
    const list = byDept.get(dept) ?? [];
    list.push(role);
    byDept.set(dept, list);
  }

  return Array.from(byDept.entries())
    .map(([dept, roles]) => `${dept}: ${roles.join(', ')}`)
    .join('\n');
}

export function formatRolesByDepartmentLines(
  profiles: EntityUserNestedProfile[] | undefined
): Array<{ department: string; roles: string }> {
  if (!profiles?.length) {
    return [];
  }

  const byDept = new Map<string, string[]>();
  for (const profile of profiles) {
    const dept = profile.department_name;
    const role = profile.profile_description || profile.profile_code;
    const list = byDept.get(dept) ?? [];
    list.push(role);
    byDept.set(dept, list);
  }

  return Array.from(byDept.entries()).map(([department, roles]) => ({
    department,
    roles: roles.join(', '),
  }));
}
